import { Dispatch } from "react";
import styles from "./CartFormCards.module.css";
import { Action } from "../../../Bundles/Types";
import { CartConfigInterface } from "../../CartTypes";
import { FormLayout, TextField } from "@shopify/polaris";
import NewCustomColorPicker from "../../../../components/NewCustomColorPicker/NewCustomColorPicker";
import TextEditorCart from "../../../../components/TextEditorCart/TextEditorCart";

const CartAdditionalNoteForm = ({
    fields,
    dispatchCartConfig,
    showCartPreview,
}: {
    submit: any;
    fields: any;
    showCartPreview: boolean;
    dispatchCartConfig: Dispatch<Action<CartConfigInterface>>;
}) => {
    const {
        additional_note: { title, Additional_notes_title_text, placeholder, cta_text },
        additional_note_design: { title_color, icon_color },
    } = fields;

    return (
        <>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>General</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <TextEditorCart
                            placeholder={"Additional Note"}
                            value={title.value}
                            onChange={(value: any) => {
                                const cleanedValue = value === "<p><br></p>" ? "" : value;
                                title.onChange(cleanedValue);
                                dispatchCartConfig({
                                    payload: {
                                        title: cleanedValue,
                                    },
                                    isComplex: true,
                                    key: "additional_note",
                                });
                            }}
                            error={title?.error}
                        />
                    </div>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <TextField
                            label={"Placeholder Text"}
                            placeholder={"Special instruction for seller"}
                            autoComplete={"off"}
                            {...placeholder}
                            onBlur={placeholder?.onBlur}
                            onChange={(val) => {
                                dispatchCartConfig({
                                    payload: {
                                        placeholder: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note",
                                });
                                placeholder.onChange(val);
                            }}
                            maxLength={80}
                            showCharacterCount
                        />
                    </div>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <TextField
                            label={"Label Text"}
                            placeholder={"Label Text"}
                            autoComplete={"off"}
                            {...Additional_notes_title_text}
                            onBlur={Additional_notes_title_text?.onBlur}
                            onChange={(val) => {
                                dispatchCartConfig({
                                    payload: {
                                        Additional_notes_title_text: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note",
                                });
                                Additional_notes_title_text.onChange(val);
                            }}
                            maxLength={80}
                            showCharacterCount
                        />
                    </div>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <TextField
                            label={"Button Text"}
                            placeholder={"Button Text"}
                            autoComplete={"off"}
                            {...cta_text}
                            onBlur={cta_text.onBlur}
                            onChange={(val) => {
                                dispatchCartConfig({
                                    payload: {
                                        cta_text: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note",
                                });
                                cta_text.onChange(val);
                            }}
                            maxLength={40}
                            showCharacterCount
                        />
                    </div>
                </FormLayout>
            </div>

            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Color</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={title_color.value}
                            setHexColor={(val) => {
                                title_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        title_color: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note_design",
                                });
                            }}
                            label={"Title Color"}
                            props={{
                                ...title_color,
                                onBlur: () => title_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={icon_color.value}
                            setHexColor={(val) => {
                                icon_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        icon_color: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note_design",
                                });
                            }}
                            label={"Label Color"}
                            props={{
                                ...icon_color,
                                onBlur: () => icon_color?.runValidation(),
                            }}
                        />

                        {/* <NewCustomColorPicker
                            hexColor={cta_bg_color.value}
                            setHexColor={(val) => {
                                cta_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cta_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note_design",
                                });
                            }}
                            label={"Button Background"}
                            props={{
                                ...cta_bg_color,
                                onBlur: submit,
                            }}
                        /> */}
                        {/* <NewCustomColorPicker
                            hexColor={cta_text_color.value}
                            setHexColor={(val) => {
                                cta_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cta_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note_design",
                                });
                            }}
                            label={"Button Text"}
                            props={{
                                ...cta_text_color,
                                onBlur: submit,
                            }}
                        /> */}

                        {/* <NewCustomColorPicker
                            hexColor={cta_bg_hover_color.value}
                            setHexColor={(val) => {
                                cta_bg_hover_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cta_bg_hover_color: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note_design",
                                });
                            }}
                            label={"Button Hover Background"}
                            props={{
                                ...cta_bg_hover_color,
                                onBlur: submit,
                            }}
                        /> */}
                        {/* <NewCustomColorPicker
                            hexColor={cta_text_hover_color.value}
                            setHexColor={(val) => {
                                cta_text_hover_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cta_text_hover_color: val,
                                    },
                                    isComplex: true,
                                    key: "additional_note_design",
                                });
                            }}
                            label={"Button Text Hover"}
                            props={{
                                ...cta_text_hover_color,
                                onBlur: submit,
                            }}
                        /> */}
                    </div>
                </FormLayout>
            </div>
        </>
    );
};

export default CartAdditionalNoteForm;
